import BaseService           from '@/core/services/BaseService';
import TransportDowntime     from '@/domains/TransportDowntime/TransportDowntime';
import TransportDowntimesDAO from '@/domains/TransportDowntime/TransportDowntimesDAO';

class TransportDowntimesService extends BaseService {

    static get dao() {
        return TransportDowntimesDAO;
    }

    /** Загружает список простоев по ЗТК */
    static async getList(
      filters?: Parameters<typeof TransportDowntimesDAO.getList>[0]
    ): Promise<TransportDowntime[]> {
        const response = await this.dao.getList(filters);
        return this.core.utils.hydrateArray(response.data, TransportDowntime.fromServer);
    }

    /** Загружает один простой по ID */
    static async get(id: number): Promise<TransportDowntime | null> {
        const response = await this.dao.getList({ id });
        const list = this.core.utils.hydrateArray(response.data, TransportDowntime.fromServer);
        return list[0] ?? null;
    }

    /** Создаёт или обновляет простой */
    static async upsert(transportDowntime: TransportDowntime): Promise<number> {
        const response = await this.dao.upsert(transportDowntime);

        if (response.ok) {
            this.core.showNotification.success('Простой успешно сохранён');
        }

        return response.data;
    }

    /** Удаляет простой по ID */
    static async delete(id: number): Promise<boolean> {
        const response = await this.dao.delete(id);

        if (response.ok) {
            this.core.showNotification.success('Простой успешно удалён');
        }

        return response.ok;
    }
}

export default TransportDowntimesService;
